import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { contentShape } from '../../common/components/proptypes/commonProptypes';

const ContentLink = ({
  contentItem,
  projectId,
  viewPathCreator,
  ariaLabel,
}) => (
  <div className="content-link">
    <Link
      to={viewPathCreator(projectId, contentItem.contentThreadId, contentItem)}
      data-testid={`content-detail-link${contentItem.contentThreadId}`}
      aria-label={ariaLabel}
    >
      {contentItem.title}
    </Link>
  </div>
);

ContentLink.propTypes = {
  contentItem: contentShape.isRequired,
  projectId: PropTypes.string.isRequired,
  viewPathCreator: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export default ContentLink;
